import { FullscreenExitOutlined, FullscreenOutlined } from "@ant-design/icons";
import { Button } from "antd";
import { useCompare } from "../../../providers";
import styles from "./CompareButton.module.css";

const CompareButton = () => {
  const { isComparing, toggleCompare } = useCompare();

  return (
    <div className={styles.container}>
      <Button
        type="text"
        className={styles.button}
        icon={isComparing ? <FullscreenExitOutlined /> : <FullscreenOutlined />}
        onClick={toggleCompare}
      >
        {isComparing ? "Sortir de la vista ampliada" : "Ampliar vista"}
      </Button>
    </div>
  );
};

export default CompareButton;
